import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
    const isAuthenticated = sessionStorage.getItem('authToken'); 

    if (!isAuthenticated) {
        return <Navigate to="/Admin" replace />;
    }

    return children;
};

export default ProtectedRoute;
